import { useEffect, useRef } from 'react';
import { makeStyles } from "@material-ui/core";
import EColourPanel from '../../../interfaces/EColourPanel';
import { useTranslation } from 'react-i18next';
import { SELF_SIGNUP_URL } from '../../../const/URL.const';
import { useQuery } from '../../util/useQuery';
import { loginFormRows } from "../../../formSchemas/login.form";
import { Link } from 'react-router-dom';
import hostClient from '../../../yoello-lib/modules/host/HostClient';
import { hosts } from '../../../yoello-lib/modules/host/Hosts';
import DynamicForm from '../../../yoello-lib/modules/dynamicForms/DynamicForms';
import { useLoginView } from './useLoginView';
import { SetPasswordView } from '../SetPasswordView/SetPasswordView';
import { useDispatch } from 'react-redux';
import { setMDLanguage } from '../../../actions/language';

const useStyles = makeStyles({
    root: {
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: "1rem",
        lineHeight: "1.5rem",
        margin:0,
        marginTop:"1.25rem",
        color: "#212121",
    }
  });
  

const LoginView = () => {
    const { isLoading, onSubmit, state  } = useLoginView();
    const { root } = useStyles();
    const { t } = useTranslation();
    const query = useQuery();
    const { current: formData } = useRef({ username: query.get('email') });

    const dispatch = useDispatch();

    useEffect(() => {
        if(hostClient.host === hosts.bna){
            dispatch(setMDLanguage('ca'));
        }
    }, [dispatch]);

    if(state){
        return <SetPasswordView {...state}/>
    }

    return <>
    <DynamicForm onHandleSubmit={onSubmit}
    formData={formData}
    formRows={loginFormRows(t)}
    formKeyName="login"
    formButtons={
        {
            rightButton: {
                type: "submit",
                label: t("misc.login"), color: EColourPanel.PRIMARY,
                fullWidth: true,
                disabled:isLoading
            }
        }
    } />
    {hostClient.host !== hosts.eposnow && hostClient.host !== hosts.worldpay && <p className={root}
    >{t("forms.login.noAccountText")}<Link to={SELF_SIGNUP_URL} style={{color: "#616161", textDecoration:"none"}}>{t("forms.login.signupNow")}</Link></p>}  
    </>
            
};

export default LoginView;